module.exports = __webpack_public_path__ + "static/3unitFJJ-6718458f946eceb96ba10bdfe526f03a.jpg";